module.exports = __webpack_public_path__ + "img/icon_image_zloading@3x.94728be1.png";